import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import useClassificacaoTributarias from "core/features/cnae/hooks/useClassificacaoTributarias";

export interface SelectClassificacaoTributariaProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectClassificacaoTributaria({
  value,
  onChange,
  ...rest
}: SelectClassificacaoTributariaProps) {
  const { isLoading, data } = useClassificacaoTributarias();

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione"
      value={value}
      allowClear
      showSearch
      onChange={onChange}
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectClassificacaoTributaria;
